import { render, staticRenderFns } from "./RegisterChargerDialog.vue?vue&type=template&id=1d36b51f&lang=pug&"
import script from "./RegisterChargerDialog.vue?vue&type=script&lang=ts&"
export * from "./RegisterChargerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports